:host {
  @include reset-host;
}

:host .video-thumbnail-group {
  &.has-dark-theme {
    --paragraph-color: #{$white};
    color: $white;
  }
}

:host .text-wrapper {
  max-width: rem(486);
}

:host .videos {
  display: flex;
  gap: map-get($spacing-sizes, 4);

  @include mq('max', 'md') {
    flex-direction: column;
  }
}

:host .main-video {
  flex: 1;
}

:host .other-videos {
  flex: 1;

  .other-videos-title {
    margin-bottom: map-get($spacing-sizes, 1);

    font-weight: $fw-bold;
    font-size: $fs-lg;
  }

  .video-grid {
    display: flex;
    flex-basis: rem(400);
    flex-direction: column;
    gap: map-get($spacing-sizes, 2);

    @include mq('max', 'md') {
      flex: 1;
      flex-direction: row;

      margin: 0 calc($gutter-mobile * -1);
      padding: 0 $gutter-mobile;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      scroll-padding-left: $gutter-mobile;
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
